<template>
    <div> 
      <div v-if="!qualified_for_approvals"
        class="tile is-parent"
        style="max-width: 500px; margin: auto; margin-top: 50px"
      >
        <article class="tile is-child box" style>
          <div class="content">
            <div id="check" />
            <div class="icon_container">
              <svg width="91" height="91" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="45.5" cy="45.5" r="42.5" stroke="#3A67D2" stroke-width="6"/>
                <circle cx="45.5" cy="45.5" r="34.5" fill="#8FB3EC"/>
                <path d="M43.8 64.5519H31.8C29.149 64.5519 27 62.3943 27 59.7328L27.0002 30.819C27.0002 28.1575 29.1492 26 31.8002 26H53.4007C56.0517 26 58.2007 28.1575 58.2007 30.819V40.457M60.6 60.9377L63 63.3472M35.4007 35.638H49.8008M35.4007 42.8665H49.8008M35.4007 50.095H42.6008M61.8 56.1187C61.8 59.4455 59.1137 62.1425 55.8 62.1425C52.4863 62.1425 49.8 59.4455 49.8 56.1187C49.8 52.7919 52.4863 50.095 55.8 50.095C59.1137 50.095 61.8 52.7919 61.8 56.1187Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h2 style="text-align: center; margin-top: 0px"  v-if="!app_status_declined">{{ title }}</h2>
            <p class="subtitle_approval">
                Your financing application with <span class="cardiff_word">Cardiff</span> is complete!
            </p>
            <br/>
            <div style="width: 100%;text-align: center;margin-bottom: 32px;">
              <div id="summary_table">
                <div class="summary_row border" style="padding-top: 12px;">
                  <div style="width: 88px;padding-top: 2px;" class="left_column">DATE</div>
                  <div style="width: 146px;" class="right_column"> {{ current_date }}</div>
                  <!-- <hr class="summary_divider"> -->
                </div>
                <div class="summary_row border" >
                  <div style="width: 160px;" class="left_column">REQUESTED AMOUNT</div>
                  <div class="right_column"> {{ requested_amount  }}</div>
                  <!-- <hr class="summary_divider"> -->
                </div>
                <div class="summary_row" style="padding-bottom: 12px;">
                  <div style="width: 176px;height: 27px;padding-top: 6px;" class="left_column">STATUS</div>
                  <div class="right_column" id="status_pending" v-if="!app_status_declined">Pending</div>
                  <div class="right_column" id="status_pending" v-if="app_status_declined">Declined</div>
                </div>
              </div>
            </div>

            

            <div class="notes_next" v-if="!app_status_declined">
              <strong>What’s next?</strong> You'll receive a qualification confirmation via SMS and/or email. Your Cardiff Account Manager will guide you through the funding process.
            </div>


            <div class="notes_next"  v-if="app_status_declined">
              <strong>What’s next?</strong> Your Application did not meet our minimum elegibility requirement for one of the following reasons: Business Tenure, Business Revenue, Business/Personal Credit, we encourage you to apply in 3 months.
            </div>



          </div>
          <!-- <div id="approval_checkbox_sms" v-if="show_sms_optin">
            <Checkbox
              :inputField="inputs.smsOptIn"
              inputName="SMS Optin"
              inputType=""
            >
              By checking this box, you agree to receive <b>application status and funding decision notifications</b> along with recurring automated promotional and personalized marketing text messages from Cardiff at the cell number used when signing up. Consent is not a condition of any purchase. 
              Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. 
              View <a href="https://attnl.tv/t/3Rk" target="_blank">Terms</a> & <a href="https://attnl.tv/p/3Rk" target="_blank">Privacy</a>.
            </Checkbox>
          </div> -->
          <div id="notification_subscribed">Your preferences were updated!</div>
          <div class="buttons is-right" id="continue-prequalified-container" v-if="show_sms_optin">
            <a
              class="button is-link padded-button next-button continue-button"
              @click="submit_SMS_OptIn"
              id="continue-prequalified-button"
              >Notify Me</a
            >
          </div>
        </article>
      </div>
      <div v-if="qualified_for_approvals && stage!==''"
        class="tile is-parent"
        style="max-width: 500px; margin: auto; margin-top: 50px"
      >
        <article class="tile is-child box" style>
          <div class="content">
            <h2 style="text-align: center; margin-top: 0px">Congratulations!</h2>
            <div style="text-align: center;">
              <img src="https://cardiff.b-cdn.net/img/DataTransfer.png" width="180px" height="80px"/>
            </div>
            <p style="text-align: center">
              We are procesing your Application.
              <br/>
              {{ stage_message }}
            </p>
            <div>
              <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
           
          </div>
        </article>
      </div>
      <div v-if="show_offers">
          <h3 style="margin-top: 0px; padding-left: 15px; text-align: left;font-size: 24px;">You've Pre-Qualify for<br/> a Business Loan</h3>
          <div class="tile is-parent" style=" margin: auto;">
          <article class="tile is-child box">
              <div class="content">
                <h4 class="" style="text-align: left;">Customize your loan:</h4>
                <Slider
                  :inputField="inputs.selected_approved_amount"
                  inputName="Amount"
                  :interval="5000"
                  :slider_data = "this.data_slider_approved_amount"
                  format="money"
                  :marks="test_marks"
                  ref="selected_approved_slider"
                />
                <Slider
                  :inputField="inputs.selected_terms"
                  inputName="Terms"
                  :interval="1"
                  :slider_data = "this.data_slider_approved_term"
                  :marks="true"
                  ref="selected_terms_ref"
                />
                <List
                  :inputField="inputs.selected_frequency"
                  :options="frequency_options"
                  inputName="Payment Frequency"
                  inputId="frequency"
                  :fullWidthOption="false"
                />
                <div class="level is-mobile">
                  <div class="level-left" style="font-weight: 500;">
                    Number of payments
                  </div>
                  <div class="level-right" style="font-weight: 500;">
                    {{ offer.Num_Payments__c }}
                  </div>
                </div>
              </div>
          </article>
          </div>
          <div class="buttons is-centered" style="margin-top: 30px;">
            <a class="button is-link padded-button next-button" @click="SelectOffer">Select Offer</a>
          </div>
      </div>
      <div v-if="contract_url" style="">
        <div id="modal_contract" class="modal">
          <div class="modal-content">
              <!-- <span class="close-button">&times;</span> -->
            <iframe :width="iframe_width" :height="iframe_height" :src=this.contract_url ref="iframe" id="iframe" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Input from "@/components/shared/Input";
  import Slider from "@/components/shared/Slider";
  import List from "@/components/shared/List";
  import ApplyPage from "@/components/shared/ApplyPage";
  // import Checkbox from "@/components/shared/Checkbox";
  import MyUtils from "@/utils/MyUtils";
  import $ from "jquery";
  export default {
    name: "ApprovalApply",
    components: {
      // Input,
      Slider,
      List,
      // Checkbox
    },
    props: {
      texts: Array,
      title: String,
      link: String
    },
    mixins: [ApplyPage],
    data() {
      return {
        initial_message : true,
        qualified_for_approvals :true,
        should_refresh: true,
        requested_amount: 0, 
        offer: {},
        message: "Waiting for updates....",
        show_offers: false,
        inputs: {
          selected_approved_amount: Input.model(),
          selected_terms: Input.model(),
          selected_frequency:  Input.model(),
          smsOptIn: Input.model()
        },
        stage:'',
        stage_message: '',
        frequency_options: [
          "Weekly",
          "Daily"
        ],
        contract_url: '',
        iframe_width: 0,
        iframe_height: 0,
        test_marks:true,
        data_slider_approved_amount : [],
        data_slider_approved_term: [],
        current_date: '',
        show_sms_optin: false,
        app_status_declined : false
      };
    },
    mounted: function () {
      console.log("mounted approval.vue");
      console.log('leadid',this.link);

      let requested_amount = MyUtils.getWithExpiry('requested_amount');
      // console.log(" requested_amount: ",requested_amount);
      if(requested_amount){
        this.requested_amount =  "$"+requested_amount;
      }
      let pre_offer_selected = MyUtils.getWithExpiry('pre-offer-selected');
      // console.log("pre_offer_selected: ",pre_offer_selected);
      if(pre_offer_selected){
        this.requested_amount =   `$${Number(pre_offer_selected).toLocaleString('en-US')}` ;;
      }

      let sms_optin_subscribed = MyUtils.getWithExpiry('sms_optin_subscribed');
      // console.log(" sms_optin_subscribed: ",sms_optin_subscribed);
      if(sms_optin_subscribed === false){
        this.show_sms_optin = true;
      }

      let mql_type = MyUtils.getWithExpiry('mql_type');
      console.log(" mql_type: ",mql_type);
      if(mql_type === 'DNQ'){
        this.app_status_declined = true;
      }

      // requested_amount

      let currentDate = new Date();
      this.current_date = this.humanFormatDate(currentDate);
        var self = this;
      
      for (var i = 0; i < 80; i++) {
        create(i);
      }
  
      function create(i) {
        var width = Math.random() * 20;
        var height = width * 0.4;
        var colour = "green";
  
        $('<div class="confetti-' + i + " " + colour + '"></div>')
          .css({
            width: width + "px",
            height: height + "px",
            top: -Math.random() * 20 + "%",
            left: Math.random() * 80 + "%",
            opacity: Math.random() + 0.5,
            transform: "rotate(" + Math.random() * 360 + "deg)",
          })
          .appendTo("#app");
        drop(i);
      }
  
      function drop(x) {
        $(".confetti-" + x).animate(
          {
            top: "100%",
            left: "+=" + Math.random() * 15 + "%",
          },
          Math.random() * 3000 + 2000,
          function () {
            $(".confetti-" + x).remove();
          }
        );
      }
  
    //   setTimeout(function () {
    //     var animation = lottie.loadAnimation({
    //       container: document.getElementById("check"), // the dom element that will contain the animation
    //       renderer: "svg",
    //       loop: false,
    //       autoplay: false,
    //       path: "../animations/check.json", // the path to the animation json
    //     });
    //     animation.play();
    //   }, 1000);
  
      this.checkServerStatus();
      let $heightTest = $("#app-column");
      this.iframe_height =  $heightTest.height() - 120;
      this.iframe_width =  $heightTest.width()- 20;
      if($("body").width() >= 769){
        this.iframe_height =  $("body").height()-250;
      }
    },
    methods :{
       humanFormatDate: function(date) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let month = months[date.getMonth()];
        let day = date.getDate();
        let year = date.getFullYear();

        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';

        hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
        minutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes

        return `${month} ${day}, ${year} ${hours}:${minutes}${ampm}`;
      },
      checkServerStatus: function(){
        console.log('checkServerStatus');
        const interval = 5000; // seconds
        var self = this;
        async function fetchUpdates() {
          try {
            console.log('fetch Updates');
            console.log('qualified_for_approvals', self.qualified_for_approvals);
             // Call the user-defined validation function to check if polling should stop
             if (!self.should_refresh) {
                console.log("Stopping polling as the condition is met.");
                self.should_refresh = false; // Stop polling
                return;
            }
            $.ajax({
              type: "POST",
              url: "/api/lead/offer_status",
              contentType: "application/json",
              dataType: "json",
              data: JSON.stringify({
                sf_leadid: self.link,
              }),
            })
              .done(function (response) {
                console.log("response offer_status", response);
                self.initial_message = false;
                self.stage = '';
                if(response.stage && response.stage !=''){
                  self.stage = response.stage;
                  if(self.stage == 'contracts'){
                    self.stage_message = 'Generating contracts, this could take from 5 to 30 seconds';
                  } else if(self.stage == 'plaid_json'){
                    self.stage_message = 'Getting your bank data, this could take a minute or two';
                  }
                }
                
                // we will wait for offers
                self.qualified_for_approvals = response.valid;
                self.should_refresh = response.valid;
                // console.log('setting qualified_approvals = response.valid');
                // console.log("response valid", response.valid)
                // console.log("offers", response.offers)
                if(response.offers && response.offers.length > 0){
                  self.show_offers = true;
                  self.offer = response.offers[0];
                  // const start = 5000;
                  const start = self.offer.Max_Approval__c;
                  const interval = 5000;
                  self.data_slider_approved_amount = [];
                  let v = start;
                  while(v > 0){
                    let d = { id: v , name: v };
                    self.data_slider_approved_amount.push( d );
                    v = v - interval;
                  }
                  // console.log(self.data_slider_approved_amount);
                  const start_term = self.offer.Max_Term__c;
                  const interval_term = 1;
                  self.data_slider_approved_term = [];
                  let i = start_term;
                  while(i > 0){
                    let d = { id: i , name: i };
                    // console.log(d);
                    self.data_slider_approved_term.push( d );
                    i = i - interval_term;
                  }
                  setTimeout(function(){
                    self.$refs.selected_approved_slider.initialSelectedValue(self.offer.Max_Approval__c);
                    self.$refs.selected_terms_ref.initialSelectedValue(self.offer.Max_Term__c);
                    $('#Weekly').trigger('click');
                  },1000);
                  self.should_refresh = false;
                }
  
                if(response.contract_url && response.contract_url !==''){
                  self.contract_url = response.contract_url;
                  self.should_refresh = false;
                  setTimeout(function(){
                    const modal = $("#modal_contract");
                    modal.css('display','flex'); // Show the modal
                  },3000);
                }
                
              })
              .fail(function (err) {
                console.log(err.responseText);
                self.invalid = true;
              });
              console.log("Valid response, continuing to poll");
          } catch (error) {
              console.error("Error fetching updates:", error);
          }
          // Schedule the next polling if not stopped
          if (self.should_refresh) {
              setTimeout(fetchUpdates, interval);
          }
        }
        fetchUpdates();
      },
      SelectOffer:function(){
        let self = this;
        console.log('select offer!');
        if (!self.validateInPlace()) {
          console.log("not sending any request until this is valid");
          self.clicked = false;
          return;
        }
        $.ajax({
          type: "POST",
          url: "/api/lead/select_offer",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            sf_leadid: self.link,
            selected_terms : self.inputs.selected_terms.value,
            selected_approved_amount : self.inputs.selected_approved_amount.value,
            selected_frequency : self.inputs.selected_frequency.value,
          }),
        })
          .done(function (response) {
            // console.log("response offer_status", response);
            self.should_refresh = true;
            self.show_offers = false;
            self.checkServerStatus();
          })
          .fail(function (err) {
            console.log(err.responseText);
            self.invalid = true;
          });
      },
      submit_SMS_OptIn: function(){
        let self = this;
        $.ajax({
          type: "POST",
          url: "/api/lead/select_notify_me",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            sf_leadid: self.link,
            notify_me : true
          }),
        })
        .done(function (response) {
          $('#notification_subscribed').show('slow');
          setTimeout(function(){
            $('#notification_subscribed').hide('slow');
          },10000);
        })
        .fail(function (err) {
          console.log(err.responseText);
        });
      } 
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
  [class|="confetti"] {
    position: absolute;
  }
  
  .green {
    background-color: #3cb968;
  }
  
  .level {
    margin-bottom: 10px !important;
  }
  #check {
    max-width: 20%;
    margin: auto;
    display: block;
  }
#approval_checkbox_sms .choice p{
  font-size: 8px!important;
  text-align: justify;
  text-justify: inter-word;
  line-height: 15px;
}
#approval_checkbox_sms .choice{
  padding-left: 10px;
  padding-right: 10px;
  background-color: #E0FFFF;
  border-radius: 8px;
}
#approval_checkbox_sms .columns{
  align-items: normal;
}
  </style>
<style lang="scss" scoped>
.border{
  // border-top: 1px solid white;
  // box-shadow: 0px 24px 3px -24px magenta;

  // width   : 200px;
  // height  : 50px;
  position: relative;
  z-index : 1;
  // background: #eee;
  padding-bottom: 12px;
}
.border::after{
  content : "";
  position: absolute;
  left    : 5%;
  bottom  : 0;
  height  : 1px;
  width   : 90%;  /* or 100px */
  border-top:1px solid white;
}
.summary_divider{
  width: 236px;
  height: 1px;
  background: #FFF;
  margin: 0 auto;
}
.small-input{
  width: 80%;
}
#summary_table{
    // display: flex;
    // width: 260px;
    // padding: 12px;
    // flex-direction: column;
    // align-items: center;
    // gap: 8px;

    flex-direction: column;
    justify-content: flex-start;
    // align-items: center;
    gap: 8px;
    display: inline-flex;

    border-radius: 8px;
    background: #E9F6EC;
}
.summary_row{
    // display: ruby;
    width: 260px;
    // padding-top: 12px;
    padding-left: 12px;
    padding-right: 12px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}
.left_column{
    text-align: left;
    color: #666;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    // display: inline-block;
    float: left;
}
.right_column{
    text-align: right;
    color: #000;
    text-align: right;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px; /* 135.714% */
    // display: inline-block;
    float: right;
}
#status_pending{
    width: 60px;
    height: 27px; 
    border-radius: 4px;
    background: #FFF;
    display: inline-flex;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 10px;
}
.notes_next{
    color: #666;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px; /* 135.714% */
}

  .icon_container{
    text-align: center;
    margin-bottom: 21px;
    margin-top: -65px;
  }
  .subtitle_approval{
    color: #666;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px; /* 135.714% */
  }
  .cardiff_word{
    color: #2C4CA3;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 19px;
  }

  .lds-spinner,
  .lds-spinner div,
  .lds-spinner div:after {
    box-sizing: border-box;
  }
  .lds-spinner {
    color: currentColor;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  
    margin: 0 auto;
    display: block;
  }
  .lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
  }
  .lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3.2px;
    left: 36.8px;
    width: 6.4px;
    height: 17.6px;
    border-radius: 20%;
    background: currentColor;
  }
  .lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  .lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  .lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  .lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  .lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  .lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  .lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  .lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  .lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  .lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  .lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  .lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  #notification_subscribed{
    display: none;
    margin-bottom: 10px;
    text-align: center;
  }
  
  /* Modal container (hidden by default) */
  .modal {
      display: none; /* Hidden by default */
      position: fixed; /* Stay in place */
      top: 0;
      left: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
      z-index: 1000; /* Sit on top */
      justify-content: center; /* Center the modal */
      align-items: center; /* Center the modal */
  }
  
  /* Modal content */
  .modal-content {
      background-color: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      text-align: center;
      width: 80%; /* Default width */
      // max-width: 500px; /* Max width */
  }
  
  @media (max-width: 47.999em) {
    .modal-content {
      width: 100%; /* Default width */
    }
  }
  
  /* Close button */
  // .close-button {
  //     position: absolute;
  //     top: 10px;
  //     right: 10px;
  //     font-size: 20px;
  //     font-weight: bold;
  //     cursor: pointer;
  //     color: #888;
  // }
  
  // .close-button:hover {
  //     color: black;
  // }

  </style>